export default __webpack_public_path__ + "static/media/phone.cc7281a6.svg";